import "./ErrorMessageContainer.scss";

import React from "react";

export const ErrorMessageContainer = ({ children }) => (
  <p className="ErrorMessageContainer">{children}</p>
);
